import * as algoliaStyles from '../styles/communs/algolia.module.scss';

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import HitColumns from './HitColumns';
import { useTranslation } from 'react-i18next';

const sortingOptions = {
  'default': ['internalpage', 'people', 'news', 'event', 'exedproduct'],
  'alphabetical': {
    sortFunction: (a, b) => a.type.localeCompare(b.type)
  },
  'Chercheur': ['internalpage', 'people', 'event', 'news', 'exedproduct'],
  'exedproduct': ['exedproduct', 'internalpage', 'news', 'event']
};

const AlgoliaResults = ({websiteRoot, language, searchWord, results }) => {
  const { t } = useTranslation();
  let sortBy = 'default';
  if (websiteRoot.includes('executive-education')) {
    sortBy = 'exedproduct';
  }
  const sortedResults = useMemo(() => {
    if (!results || results.length === 0) return [];

    const resultsByType = {};

    results.forEach((result) => {
      if (result.hits?.length > 0) {
        resultsByType[result.type] = result;
      }
    });

    const sortConfig = sortingOptions[sortBy] || sortingOptions.default;

    return Object.values(resultsByType)
      .filter((result) => {
        if (sortConfig.sortFunction) {
          return true;
        }
        return Array.isArray(sortConfig) ? sortConfig.includes(result.type) : true;
      })
      .sort((a, b) => {
        if (sortConfig.sortFunction) {
          return sortConfig.sortFunction(a, b);
        }

        const orderA = sortConfig.indexOf(a.type);
        const orderB = sortConfig.indexOf(b.type);

        return orderA - orderB;
      });
  }, [results, sortBy]);

  return (
    <div className={algoliaStyles.container}>
      {sortedResults.length > 0 && (
        <>
          {sortedResults.map((result) => (
            <div
              className={algoliaStyles.columns}
              key={result.type}
            >
              <HitColumns
                hits={result.hits}
                language={language}
                searchWords={searchWord}
                seeMore
                title={t(`search.${result.type}`)}
                type={result.type}
                websiteRoot={websiteRoot}
              />
            </div>
          ))}
        </>
      )}
    </div>
  );
};

AlgoliaResults.propTypes = {
  language: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    hits: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
      title: PropTypes.string,
      website: PropTypes.string,
    })).isRequired,
  })).isRequired,
  searchWord: PropTypes.string.isRequired,
  sortBy: PropTypes.string,
  websiteRoot: PropTypes.string.isRequired,
};

export default AlgoliaResults;
